export const CONSOLE_CLAIM = 'consoleurl.cluster.open-cluster-management.io';
export const HUB_CLUSTER_NAME_IN_OCM = 'local-cluster';
export const ANNOTATION_KUBERNETES_API_SERVER = 'kubernetes.io/api-server';
